export default __webpack_public_path__ + "static/media/capabilities1-image.61139706.png";